import { render, staticRenderFns } from "./DocTax.vue?vue&type=template&id=b909e086&"
import script from "./DocTax.vue?vue&type=script&lang=js&"
export * from "./DocTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports